import React from 'react';
import { styled as styled2 } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { ProjectCreateSuccessCallbackPayload } from './common/types';

export const loadProjectCreateBundle = () =>
	import(/* webpackChunkName: "async-project-create" */ './index');

/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */
const LazyComponent = lazy(() => import(/* webpackChunkName: "async-project-create" */ './index'));

export const AsyncProjectCreate = (props: Props) => (
	<JSErrorBoundary
		id="bundle-async-project-create"
		fallback="flag"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<Placeholder
			name="project-create"
			fallback={
				<Center>
					<Spinner size="large" />
				</Center>
			}
		>
			<LazyComponent {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncProjectCreate;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Center = styled2.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100vh',
});
